import axios from 'axios';

import jwtService from '../services/jwt.service';
import apiService from '../services/api.service';
import config from '../services/config.service';

export default {
  state: {
    error: null,
    user: null,
    isAuthenticated: false,
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
      localStorage.setItem('user', JSON.stringify(user));
      axios.defaults.headers.common['x-auth-token'] = user.token;
      location.reload();
    },
    CLEAR_USER(state) {
      localStorage.removeItem('user');
      state.user = null;
      axios.defaults.headers.common['x-auth-token'] = null;
      state.isAuthenticated = false;
      jwtService.destroyTokens();
    },
    SET_ERROR(state, error) {
      state.error = error;
      state.isAuthenticated = false;
    },
    SET_AUTH(state, data) {
      state.error = null;
      state.isAuthenticated = !!(data && data.token);
    },
    PURGE_AUTH(state) {
      state.isAuthenticated = false;
      state.error = null;
    },
  },
  actions: {
    async setApiKey(context, sessionTokens = {}) {
      try {
        const sessionToken = jwtService.getSessionToken();
        const { token } = await apiService.post(
          '/auth/tokens/login',
          {
            sid: config.SERVICES_UID,
          },
          {
            headers: { 'x-auth-token': sessionToken },
          }
        );
        jwtService.saveApiKey(token);
        const auth = {
          ...sessionTokens,
          token,
        };
        context.commit('SET_AUTH', auth);
        return auth;
      } catch (error) {
        jwtService.destroyTokens();
        context.commit('SET_ERROR', error);
      }
    },
    async setSessionToken(context, { sessionToken, refreshToken }) {
      try {
        jwtService.saveSessionToken(sessionToken);
        jwtService.destroyApiKey();
        const auth = await context.dispatch('setApiKey', { sessionToken, refreshToken });
        return auth;
      } catch (error) {
        jwtService.destroyTokens();
        context.commit('SET_ERROR', error);
      }
    },
    logout({ commit }) {
      commit('CLEAR_USER');
    },
  },
};
